import { ref, nextTick } from 'vue'
import { useAttachments } from '@/composables/useAttachments'
import { generateEmbedFileName } from '@/utils'
import { useStore } from '@/store'

const editor = ref(null)
const insertImage = ref(null)
const insertLink = ref(null)
const embeddingImageIds = ref([])

export function useEditor() {
  const store = useStore()
  const { uploadImageCopy, deleteAttachment, doAndReload } = useAttachments()

  function setEditor(editorData) {
    editor.value = editorData.editor
    insertImage.value = editorData.insertImage
    insertLink.value = editorData.insertLink
  }

  async function handleEmbedImage(
    image,
    options = { removeCopy: false, width: '200px' },
  ) {
    embeddingImageIds.value.push(image.id)
    await nextTick()
    let { removeCopy, width } = options
    const imageName = generateEmbedFileName(image)
    let response
    let upStatus
    try {
      response = await uploadImageCopy(image, imageName)
      upStatus = response.status
    } catch (e) {
      upStatus = e.response.status
      const iDel = embeddingImageIds.value.indexOf(image.id)
      iDel !== -1 && embeddingImageIds.value.splice(iDel, 1)

      const errMsg = e.response.data.message
        ? ` (${e.response.data.message})`
        : ''
      store.commit('notify', {
        type: 'error',
        message: `Could not embed image ${image.name}${errMsg}`,
      })
    }
    if (upStatus === 200 || upStatus === 201) {
      const { status, data: uploadedImage } = response
      if (status === 201) {
        if (removeCopy) deleteAttachment(image.id)
        insertImage.value({
          src: uploadedImage.direct_url,
          title: uploadedImage.name,
          alt: uploadedImage.name,
          width,
        })
      }
      const iDel = embeddingImageIds.value.indexOf(image.id)
      iDel !== -1 && embeddingImageIds.value.splice(iDel, 1)
    }
    return response
  }

  async function handleEmbedImages(images, options) {
    return Promise.all(images.map((img) => handleEmbedImage(img, options)))
  }

  async function handleInsertLinks(links) {
    const wrapLinks = links.length > 1
    return links.forEach((link) => {
      const innerHtml = link.innerHtml
      delete link.innerHtml
      insertLink.value(link, innerHtml, wrapLinks)
    })
  }

  return {
    editor,
    setEditor,
    insertImage,
    handleInsertLinks: handleInsertLinks,
    handleEmbedImage: doAndReload(handleEmbedImage),
    handleEmbedImages: doAndReload(handleEmbedImages),
    embeddingImageIds,
  }
}
